module.exports = __webpack_public_path__ + "assets/icons/ic_star_border-9727.svg";